import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import FoundationIcon from "@mui/icons-material/Foundation";
import SalesSchedule from "./SalesSchedule";
import BlueprintSpecSheet from "./BlueprintSpecSheet";
import StockTrussForm from "./StockTrussForm";
import SnowLoadMap from "./SnowLoadMap";
import SpecSheetQueue from "./SpecSheetQueue";
import { PageHeader, PageShell } from "../../components/UI/Page";
import { SbcfEmbedContext, Segmented } from "../../components/SBCF/ui";

// Sales-facing SBCF dashboard. The staff side (spec sheet queue, team
// workload, form admin) lives at /sbcfadmin.
const NAV_ITEMS = [
  { label: "Sales Schedule" },
  { label: "Blueprint Spec Sheet" },
  { label: "My Submissions" },
  { label: "Snow Load Finder" },
  { label: "Common Stock RFQ", disabled: true },
];

const isDisabledView = (view) =>
  NAV_ITEMS.some((item) => item.label === view && item.disabled);

const SBCFDashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const paramView = searchParams.get("view");
  const initialView =
    paramView && !isDisabledView(paramView) ? paramView : "Sales Schedule";
  const [selectedNav, setSelectedNav] = useState(initialView);

  useEffect(() => {
    setSearchParams({ view: selectedNav });
  }, [selectedNav, setSearchParams]);

  const renderView = () => {
    switch (selectedNav) {
      case "Sales Schedule":
        return <SalesSchedule />;
      case "Blueprint Spec Sheet":
        return <BlueprintSpecSheet />;
      case "My Submissions":
        return <SpecSheetQueue key="sales" mode="sales" />;
      case "Common Stock RFQ":
        return <StockTrussForm />;
      case "Snow Load Finder":
        return <SnowLoadMap />;
      default:
        return null;
    }
  };

  return (
    <PageShell size="2xl">
      <PageHeader
        icon={FoundationIcon}
        tone="orange"
        eyebrow="SBCF"
        title="SBCF Dashboard"
        description="Sales schedule, spec sheets, stock truss RFQs, and snow load lookup."
      >
        <Segmented
          className="mt-5"
          ariaLabel="SBCF dashboard view"
          value={selectedNav}
          onChange={setSelectedNav}
          options={NAV_ITEMS.map(({ label, disabled }) => ({
            value: label,
            label,
            disabled,
            title: disabled ? "Coming soon" : undefined,
          }))}
        />
      </PageHeader>

      <SbcfEmbedContext.Provider value={true}>
        {renderView()}
      </SbcfEmbedContext.Provider>
    </PageShell>
  );
};

export default SBCFDashboard;
